import { ActionType } from 'typesafe-actions';
import BaseReducer, {
baseInitialState,
} from '../../../../../boilerplate/redux/BaseReducer';
import { IBaseStateType } from '../../../../../boilerplate/redux/types/IBaseStateType';
import * as themeworldWidgetActions from './themeworldWidgetActions';

export type ThemeworldWidgetAction = ActionType<typeof themeworldWidgetActions>;

export interface IThemeworldWidgetStateType extends IBaseStateType {
	readonly entryMap: { [queryKey: string]: IThemeworldWidgetType };
	readonly queries: { [queryKey: string]: IThemeworldWidgetType[] };
}

export function themeworldWidgetReducer(
	state = baseInitialState as IThemeworldWidgetStateType,
	action: ThemeworldWidgetAction,
) {
	const Reducer = new BaseReducer('themeworldWidgetReducer', 'slug');

	return Reducer.extend(state, action, (innerState, innerAction) => {
		switch (innerAction.type) {
			case 'OTHER_ACTION_TYPE':
				return Object.assign({}, innerState, {
					data: null,
					done: false,
					error: null,
					loading: true,
				});

			default:
				return innerState;
		}
	});
}
